import React from 'react';

const Pagination = ({ currentPage = 1, totalCount = 0, pageSize = 10, onPageChange }) => {
  if (!totalCount) return null;
  const totalPages = Math.ceil(totalCount / pageSize);
  if (totalPages <= 1) return null;

  const handleChange = (page) => {
    if (page < 1 || page > totalPages || page === currentPage) return;
    onPageChange?.(page);
  };

  const getPages = () => {
    const pages = [];
    const start = Math.max(1, currentPage - 2);
    const end   = Math.min(totalPages, currentPage + 2);
    for (let i = start; i <= end; i++) pages.push(i);
    return { pages, start, end };
  };

  const { pages, start, end } = getPages();
  const from = (currentPage - 1) * pageSize + 1;
  const to   = Math.min(currentPage * pageSize, totalCount);

  return (
    <div className="pagination-wrap">
      <div className="pagination-info">
        Showing <strong>{from}</strong> to <strong>{to}</strong> of <strong>{totalCount}</strong> records
      </div>

      <div className="pagination-controls">
        <button className="pg-btn" disabled={currentPage === 1} onClick={() => handleChange(currentPage - 1)}>
          Prev
        </button>

        {start > 1 && (
          <>
            <button className="pg-btn" onClick={() => handleChange(1)}>1</button>
            {start > 2 && <span className="text-[#9AA5B4] text-xs px-1">…</span>}
          </>
        )}

        {pages.map(page => (
          <button
            key={page}
            onClick={() => handleChange(page)}
            className={`pg-btn${page === currentPage ? ' active' : ''}`}>
            {page}
          </button>
        ))}

        {end < totalPages && (
          <>
            {end < totalPages - 1 && <span className="text-[#9AA5B4] text-xs px-1">…</span>}
            <button className="pg-btn" onClick={() => handleChange(totalPages)}>{totalPages}</button>
          </>
        )}

        <button className="pg-btn" disabled={currentPage === totalPages} onClick={() => handleChange(currentPage + 1)}>
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;
